// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-7b5008eb]{padding-bottom:30px;padding-top:30px}", "",{"version":3,"sources":["webpack://./resources/client/components/footer/FooterComponent.scss"],"names":[],"mappings":"AAAA,yBAEE,mBAAA,CADA,gBAEF","sourcesContent":[".footer {\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
